// The person detail dialog is opened by a search parameter rather than by
// component state, so a name anywhere in the app can link to it with a real
// anchor (opens in a new tab, can be shared, Back closes it), and one host in
// the app shell renders it over whatever page is underneath.
export const PERSON_DETAIL_PARAM = "osoba";

/** The current location with the person detail dialog opened over it. */
export function personDetailHref(pathname: string, search: string, personId: string): string {
  const params = new URLSearchParams(search);
  params.set(PERSON_DETAIL_PARAM, personId);
  return `${pathname}?${params.toString()}`;
}
